import { useFormContext, useWatch } from "react-hook-form";
import { PurchaseOrdersFormTyping } from "../../types";
import { useGetModuleSupplierQuery } from "@redux/features/suppliers/suppliersApi";
import LanguageDropdownSection from "@ready/language";
import { useShouldSkipCopyAutofill } from "../../CopyHydrationContext";

const LANGUAGE_STORAGE_KEY = "purchase-order.language";

export default function LanguageSection() {
    const { control } = useFormContext<PurchaseOrdersFormTyping>();

    const supplier = useWatch({
        control,
        name: "supplier",
    });
    const shouldSkipCopyAutofill = useShouldSkipCopyAutofill(supplier?.id);

    const mode = useWatch({
        control,
        name: "mode",
    });

    const { data: extendedSupplierData, isFetching: isExtendedSupplierDataFetching } =
        useGetModuleSupplierQuery(
            { module: "purchase-order", id: supplier?.id as number },
            { skip: !supplier || mode === "editing" }
        );

    const activeSupplierData =
        extendedSupplierData?.id === supplier?.id ? extendedSupplierData : undefined;

    return (
        <LanguageDropdownSection
            storageKey={LANGUAGE_STORAGE_KEY}
            entityId={supplier?.id}
            entityLanguage={activeSupplierData?.language}
            isEntityDefaultPending={
                mode === "creation" &&
                !!supplier?.id &&
                !activeSupplierData &&
                isExtendedSupplierDataFetching
            }
            skipInitialEntityHydration={shouldSkipCopyAutofill}
            translationKeyPrefix="purchaseOrder.language"
        />
    );
}
